<template>
  <ValidationProvider
    slim
    :rules="rulesObject"
    :name="inputLabel"
    :vid="label + '-' + $id()"
    v-slot="{ errors }"
    v-show="show"
    :class="{ 'f-col-span-2': true }"
  >
    <BaseInputGroup
      :id="id"
      :label="inputLabel + (isRequired ? '*' : '')"
      :error="getFirstError(errors)"
      :single-column="singleColumn"
      :class="{ 'f-col-span-2': true }"
    >
      <template slot="input">
        <BaseTextarea
          lazy=""
          :id="id + '-input'"
          :name="name"
          v-model="value"
          @input="update"
        />
      </template>
      <template slot="error">
        <p v-if="errors.length" class="f-text-xs f-text-red-600 f-mb-0 f-mt-1">
          {{ getFirstError(errors) }}
        </p>
      </template>
    </BaseInputGroup>
  </ValidationProvider>
</template>

<script lang="ts">
import InputValidationMixin from "@/components/Form/Basic/Inputs/InputValidationMixin";
import mixins from "vue-typed-mixins";
import { ValidationProvider } from "vee-validate";
import { isStringOrNull } from "@/module/ComponentPropsValidations/validations";
import BaseInputGroup from "@/components/Form/Basic/Inputs/BaseInputGroup.vue";
import BaseTextarea from "@/components/Form/Basic/Inputs/BaseTextarea.vue";
import { PropType } from "vue";

export default mixins(InputValidationMixin).extend({
  name: "NotesInput",

  components: {
    BaseTextarea,
    BaseInputGroup,
    ValidationProvider,
  },

  props: {
    showInput: {
      type: Boolean,
      required: true,
    },
    rules: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: null as unknown as PropType<string | null>,
      required: true,
      validator: isStringOrNull,
    },
    singleColumn: {
      type: Boolean,
      required: true,
    },
  },

  data(): { inputLabel: string } {
    return {
      inputLabel: "",
    };
  },

  computed: {
    rulesObject(): object {
      return this.show ? this.rules : {};
    },

    show(): boolean {
      return true;
    },

    id(): string {
      return this.$id(this.name);
    },

    isRequired(): boolean {
      return (
        this.rules.hasOwnProperty("required") && Boolean(this.rules.required)
      );
    },
  },

  methods: {
    update(value: string | null): void {
      if (value === "") {
        value = null;
      }

      this.$emit("input", { [this.name]: value });
    },
  },

  watch: {
    show(newShowValue: boolean, oldShowValue: boolean): void {
      if (newShowValue === oldShowValue) {
        return;
      }

      let value = this.value;
      const show = this.show;

      if (!show) {
        value = null;
      }

      this.update(value);
    },
  },

  mounted(): void {
    if (!this.label || this.label === "Poznámka") {
      this.inputLabel = String(this.$t("basic_info.notes.label"));
    } else {
      this.inputLabel = this.label;
    }

    if (!this.queryParam) {
      return;
    }

    this.loadDataFromQuery();
    this.update(this.value);
  },
});
</script>

<style></style>
